import { Autocomplete, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, useMediaQuery } from '@mui/material';
import React, { ReactNode, useContext, useEffect, useState } from 'react'
import { createZohoIntegrationOrganizationChatbotAssignmentInterface, zohoContact, zohoDepartment, ZohoIntegrationOrganization, zohoTicketFields } from '../../../../../models/axiosModel';
import Required from '../../../../utility/required'; 
import integrationStyles from "../../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss"; 
import { IntegrationContext, IntegrationContextPayload } from '../../../../../context/integrationContext';
import GlobalButton from '../../../../utility/globalButton/button';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import GlobalPopUp from '../../../../utility/globalPopUp';
import GlobalDeletePopup from '../../../../utility/globalDeletePopup/globalDeletePopup';
import { ChatbotContext, ChatbotContextPayload } from '../../../../../context/chatbotContext';
import ZohoConfiguration from './zohoConfiguration';  
import DeleteIcon from '@mui/icons-material/Delete';
import globalStyles from "../../../../../assets/styles/global.module.scss";
import { useGenericStore } from '../../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface ZohoInformationCardFormProps {
    zohoTicketFields: zohoTicketFields[], 
    createZohoIntegrationPayload:createZohoIntegrationOrganizationChatbotAssignmentInterface,
    handleDescriptionChangeValue: (value: string, ind: number) => void, 
    handleStaticValueChangeValue: (value: string, ind: number) => void, 
    handleCancelClick: () => void; 
    handleIntegrateClick: () => void;
    checkDisableIntegrate: () => boolean; 
}  

interface ZohoInformationCardProps {
    zoho: ZohoIntegrationOrganization, 
}

const ZohoInformationCard: React.FC<ZohoInformationCardProps | ZohoInformationCardFormProps> = (props) => { 

  const flagZohoIntegrated = (props: any): props is ZohoInformationCardProps =>
    'zoho' in props; 

  const { deleteZohoIntegrationChatbotAssignmentApi} = useContext(IntegrationContext) as IntegrationContextPayload; 
  const { chatBotDetails, GetChatbotDataApi } = useContext(ChatbotContext) as ChatbotContextPayload;
  const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

  const { showSuccess } = useGenericStore(useShallow((state) => ({
    showSuccess: state.showSuccess
  })))

  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false); 

  const breakPoints = {
    mobileScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)')
  }
  
  const deleteZohoIntegrationChatbotAssignmentApiCall = async (zoho_integration_organization_chatbot_id: number) => {
    setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true })); 
    const res = await deleteZohoIntegrationChatbotAssignmentApi(zoho_integration_organization_chatbot_id);
    if(res.status){
      showSuccess(`Zoho Integration Deleted successfully`)
      if(chatBotDetails){
        GetChatbotDataApi(chatBotDetails.chatbot_id);
      }
    }else{
      handleError(res);
    }
    setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false })); 
  }

  return (
    <>
      <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter} ${globalStyles.alignItemCenter} ${integrationStyles.zohoInformationCardGridContainer}`}>
        <Grid item className={globalStyles.fullwidth} sx={{padding: !flagZohoIntegrated(props) ? (breakPoints.mobileScreen ? "5px 20px 20px 20px" : "15px 27px 20px 33px") : "15px 30px 30px 30px", marginTop: flagZohoIntegrated(props) ? "15px" : "",boxShadow: flagZohoIntegrated(props) ? "0px 0px 2px 0px #00000040" : "", borderRadius: flagZohoIntegrated(props) ? "12px" : ""}}> 
            {flagZohoIntegrated(props) && 
              <Grid item>
                <Grid container justifyContent={"flex-end"}> 
                    <Grid item> 
                      <GlobalButton 
                        buttonText='Delete' 
                        startIcon={<DeleteIcon sx={{ color: "white" }} />}
                        className='deleteButton' 
                        onClick={() => {setShowDeleteConfirmation(true)}} 
                        flagFullWidth 
                      />
                    </Grid>
                </Grid>
              </Grid>
            }
            {!flagZohoIntegrated(props) ? 
              <ZohoConfiguration zohoTicketFields={props.zohoTicketFields} handleDescriptionChangeValue={props.handleDescriptionChangeValue} handleStaticValueChangeValue={props.handleStaticValueChangeValue} createZohoIntegrationPayload={props.createZohoIntegrationPayload} />
              : 
              <ZohoConfiguration zoho={props.zoho} />
            }
        </Grid>
        {!flagZohoIntegrated(props) && 
          <Grid item> 
                <Grid container className={integrationStyles.zohoInformationCardBtnContainer}> 
                    <Grid item>
                        <GlobalButton
                            buttonText="Cancel"
                            sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                            className='borderedButtonStyle' 
                            onClick={() => {props.handleCancelClick()}}
                        />
                    </Grid> 
                    <Grid item>
                        <GlobalButton
                            buttonText="Integrate"
                            sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                            className='primaryButtonStyle' 
                            disabled={props.checkDisableIntegrate()}
                            onClick={() => {props.handleIntegrateClick()}}
                        />
                    </Grid>
                </Grid>
          </Grid>
        } 
      </Grid>

      {
        showDeleteConfirmation &&
        <GlobalPopUp
            open={showDeleteConfirmation}
            handleClose={() => { setShowDeleteConfirmation(false) }}
        >
            <GlobalDeletePopup
                deleteDescription={`Are you sure you want to delete ${chatBotDetails?.chatbot_name} zoho integration`}
                onClose={() => { setShowDeleteConfirmation(false) }}
                onDelete={() => {
                  setShowDeleteConfirmation(false);
                  if("zoho" in props){
                    deleteZohoIntegrationChatbotAssignmentApiCall(props.zoho.zoho_integration_organization_chatbot_id);
                  }
                }}
            />
        </GlobalPopUp>
      }
    </>
  )
}

export default ZohoInformationCard
